import React from "react";
import { LegalPage, LegalSection, LegalIntro, LegalList, LegalAddress } from "../../components/LegalPage";

/* Copy is VERBATIM from Dr_Tania_Approved_Legal_Page_Copy_2026-08-03.md.
 * Do not paraphrase, shorten, expand or reorder.
 * privacy@drtaniasingh.com must not be substituted. */

export default function Privacy() {
  return (
    <LegalPage
      title="Privacy & Consent"
      effectiveDate="Effective date: 3 August 2026"
      seoTitle="Privacy & Consent | Dr Tania Gurdip Singh"
      seoDescription="This Privacy & Consent Policy explains how personal information is collected, used, stored and protected when you visit drtaniasingh.com, request a consultation, submit a pregnancy question or communicate with Dr Tania Gurdip Singh and HIGH RISKK PREGNANCY CLINIC through this website."
      canonical="/privacy"
    >
      <LegalIntro>
        <p>
          This Privacy &amp; Consent Policy explains how personal information is collected,
          used, stored and protected when you visit drtaniasingh.com, request a consultation,
          submit a pregnancy question or communicate with Dr Tania Gurdip Singh and HIGH RISKK
          PREGNANCY CLINIC through this website.
        </p>
        <p>
          For this policy, “Dr Tania”, “we”, “us” and “our” refer to Dr Tania Gurdip Singh,
          practising through HIGH RISKK PREGNANCY CLINIC.
        </p>
      </LegalIntro>

      <LegalSection n={1} title="Information you may provide">
        <p>When you use the Book a Consultation form, we may collect:</p>
        <LegalList items={[
          "Your name",
          "Telephone number",
          "Optional email address",
          "City",
          "Consultation preference",
          "Preferred consultation date",
          "Whether you are a patient or referring healthcare professional",
          "A brief reason for consultation",
          "Referring-doctor details, where applicable",
          "Your consent to be contacted",
        ]}/>
        <p>When you use Ask a Question, we may collect:</p>
        <LegalList items={[
          "Whether you are a patient, caregiver, doctor or another visitor",
          "The general topic of your question",
          "The question you submit",
          "Your consent for the question to be reviewed, edited and anonymised for possible educational use",
        ]}/>
        <p>
          Please do not submit reports, prescriptions, photographs, identification documents,
          detailed medical histories or information identifying another person through these
          public forms.
        </p>
        <p>
          The website may also collect limited technical information such as browser type,
          device information, IP address, security logs, error logs and page-performance
          information.
        </p>
      </LegalSection>

      <LegalSection n={2} title="How we use information">
        <p>We may use personal information to:</p>
        <LegalList items={[
          "Review consultation requests",
          "Contact you regarding availability and next steps",
          "Arrange an in-person consultation or teleconsultation",
          "Respond to administrative questions",
          "Place enquiries in the secure administrative Enquiry Inbox",
          "Notify authorised staff about new enquiries",
          "Review submitted educational questions",
          "Develop future Articles or Clinical Insights from anonymised questions",
          "Protect the website against spam, misuse or security threats",
          "Maintain records required for administrative, professional or legal purposes",
          "Comply with lawful requests from authorised authorities",
        ]}/>
        <p>
          Submitting a form does not confirm an appointment and does not, by itself, create a
          doctor–patient relationship.
        </p>
      </LegalSection>

      <LegalSection n={3} title="Consent">
        <p>
          By submitting a consultation request, you consent to being contacted using the
          telephone number or optional email address that you provide.
        </p>
        <p>
          By submitting a question through Ask a Question, you consent to its editorial
          review and to its possible use in an edited and anonymised form for general
          educational content.
        </p>
        <p>
          You may withdraw consent for future processing by contacting us. Withdrawal does
          not affect processing already completed lawfully or information that must be
          retained for professional, legal, security or record-keeping purposes.
        </p>
      </LegalSection>

      <LegalSection n={4} title="Health-related information">
        <p>
          Pregnancy and health information can be sensitive. The public forms have therefore
          been intentionally designed to collect only limited information.
        </p>
        <p>
          They are not intended to receive detailed clinical records and are not a substitute
          for a secure clinical consultation.
        </p>
        <p>
          Where a consultation is formally accepted and conducted, information collected
          during that consultation may become part of a separate clinical record governed by
          applicable professional and legal obligations.
        </p>
      </LegalSection>

      <LegalSection n={5} title="Sharing and service providers">
        <p>We do not sell or rent personal information.</p>
        <p>Information may be processed by authorised service providers supporting:</p>
        <LegalList items={[
          "Website hosting",
          "Database storage",
          "Email delivery",
          "Domain and email hosting",
          "Website security",
          "Anti-spam protection",
          "Technical maintenance",
        ]}/>
        <p>Only information reasonably required for the relevant service should be shared.</p>
        <p>
          Some service providers may process or store information outside India. Where this
          occurs, we seek to use providers offering appropriate technical, organisational and
          contractual safeguards, subject to applicable Indian law.
        </p>
        <p>
          We may also disclose information where required by law, court order or regulatory
          authority, or where reasonably necessary to protect safety, rights or security.
        </p>
      </LegalSection>

      <LegalSection n={6} title="Retention">
        <p>
          Personal information is retained only for as long as reasonably necessary for the
          purpose for which it was collected, including enquiry management, security, legal
          compliance and dispute resolution.
        </p>
        <p>
          Enquiries that do not progress to a consultation are periodically reviewed and may
          be deleted when they are no longer operationally or legally required.
        </p>
        <p>
          Questions submitted for editorial consideration may be retained for longer where
          they remain relevant to planned educational content. Any public use should be
          edited and anonymised.
        </p>
        <p>
          Where a consultation proceeds, relevant information may be retained separately as
          part of the clinical record in accordance with applicable professional and legal
          requirements.
        </p>
      </LegalSection>

      <LegalSection n={7} title="Your choices and rights">
        <p>Subject to applicable law, you may request:</p>
        <LegalList items={[
          "Information about personal data held about you",
          "Correction of inaccurate or incomplete data",
          "Erasure of data that is no longer required",
          "Withdrawal of consent for future processing",
          "Information about how to raise a grievance",
          "Nomination of another person to exercise applicable rights in circumstances recognised by law",
        ]}/>
        <p>
          A request may require reasonable verification of identity to protect your
          information from unauthorised disclosure.
        </p>
      </LegalSection>

      <LegalSection n={8} title="Children and adolescents">
        <p>
          Individuals under 18 should not submit personal information, request a consultation
          or send a question without the involvement and consent of a parent or lawful
          guardian.
        </p>
      </LegalSection>

      <LegalSection n={9} title="Security">
        <p>
          Reasonable administrative and technical safeguards are used to protect information
          from unauthorised access, loss, alteration or disclosure.
        </p>
        <p>
          No internet transmission or storage system can be guaranteed to be completely
          secure. Please avoid submitting unnecessary or detailed medical information through
          public forms.
        </p>
      </LegalSection>

      <LegalSection n={10} title="Cookies and technical technologies">
        <p>
          The website may use essential cookies, session technologies and security tools
          required for navigation, form protection and administrative access.
        </p>
        <p>
          Technical or performance information may be collected to identify errors and
          improve reliability.
        </p>
        <p>
          The website does not currently use personal data for third-party behavioural
          advertising. If analytics, advertising or additional tracking technologies are
          introduced later, this policy and any required consent mechanism should be updated.
        </p>
      </LegalSection>

      <LegalSection n={11} title="External links">
        <p>
          The website may link to third-party sources, professional bodies, publishers,
          medical references or external services. We are not responsible for the privacy
          practices or content of websites operated by other organisations.
        </p>
      </LegalSection>

      <LegalSection n={12} title="Questions and grievances">
        <p>
          For privacy questions, correction requests, consent withdrawal or data-related
          grievances, contact:
        </p>
        <LegalAddress>
          <strong>Privacy Contact</strong><br/>
          <strong>Dr Tania Gurdip Singh</strong><br/>
          <strong>HIGH RISKK PREGNANCY CLINIC</strong><br/>
          A-78A, Veer Savarkar Marg<br/>
          Opposite SBI Bank, Lajpat Nagar II<br/>
          New Delhi – 110024<br/>
          <strong>Email: privacy@drtaniasingh.com</strong>
        </LegalAddress>
        <p>
          We will review genuine requests and respond within a reasonable period, subject to
          identity verification and applicable legal requirements.
        </p>
      </LegalSection>

      <LegalSection n={13} title="Changes to this policy">
        <p>
          This policy may be updated when website functions, service providers or legal
          requirements change. The current effective date will be displayed at the top of
          the page.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
